/**
 * @group Project
 * @summary Project copyright
 * 
 * @remarks
 * This constant contains the project copyright notice used in footers,
 * legal pages, and other areas requiring copyright information.
 * 
 * @example
 * ```typescript
 * import { PROJECT_COPYRIGHT } from '@shared/constants';
 * 
 * const footer = document.querySelector('footer');
 * if (footer) {
 *   footer.innerHTML = `<p>${PROJECT_COPYRIGHT}</p>`;
 * }
 * ```
 */
export const PROJECT_COPYRIGHT = `&copy; ${new Date().getFullYear()} K2021/010617/07 (Pty) Ltd. All rights reserved.`; 